import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createProductsFiltersDrawerOpenIntent({
  requestFilter,
  selectedFilterGroup,
}: {
  requestFilter: string | undefined
  selectedFilterGroup: string | undefined
}): WebViewIntent {
  return createIntent('PRODUCTS_FILTERS_DRAWER_OPEN', { requestFilter, selectedFilterGroup })
}

export function createProductsFiltersDrawerCloseIntent(): WebViewIntent {
  return createIntent('PRODUCTS_FILTERS_DRAWER_CLOSE')
}

export function createProductsFiltersDrawerClearFiltersIntent(): WebViewIntent {
  return createIntent('PRODUCTS_FILTERS_DRAWER_CLEAR_FILTERS')
}

export function createProductsFiltersDrawerSelectFiltersIntent(
  requestFilter?: string,
): WebViewIntent {
  return createIntent('PRODUCTS_FILTERS_DRAWER_SELECT_FILTERS', { requestFilter })
}
